import { withInstall, withNoopInstall } from '@bigin/utils'

import Collapse from './src/collapse.vue'
import CollapseItem from './src/collapse-item.vue'

export const BCollapse = withInstall(Collapse, {
  CollapseItem,
})
export default BCollapse
export const BCollapseItem = withNoopInstall(CollapseItem)

export * from './src/collapse'
export * from './src/collapse-item'
